import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getCategoryByMarkets} from 'api/requests';
import {ICategoryResponse} from 'types';

export interface UseMarketsByCategoryOptions extends UseQueryOptions<ICategoryResponse[]> {
  locale?: string;
}

export const useMarketsByCategory = (queryKey: QueryKey, options?: UseMarketsByCategoryOptions) => {
  const {locale, ...queryOptions} = options || {};

  return useQuery<ICategoryResponse[]>({
    queryKey,
    queryFn: () => getCategoryByMarkets(locale),
    ...queryOptions,
  });
};
